module.exports = __webpack_public_path__ + "static/media/machat.3e0e4640.png";